var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30719 9.42864C3.30576 8.41247 3.50539 7.40607 3.89458 6.46738C4.28376 5.5287 4.85482 4.67629 5.57485 3.95924C6.29488 3.2422 7.14965 2.6747 8.08995 2.28942C9.03024 1.90414 10.0375 1.7087 11.0536 1.71435C15.2965 1.7465 18.6929 5.2715 18.6929 9.52507V10.2858C18.6929 14.1215 19.4965 16.3501 20.2036 17.5715C20.2787 17.7016 20.3183 17.8491 20.3185 17.9993C20.3186 18.1495 20.2793 18.2971 20.2044 18.4273C20.1295 18.5575 20.0217 18.6658 19.8918 18.7412C19.762 18.8167 19.6145 18.8567 19.4643 18.8572H2.53576C2.38556 18.8567 2.23813 18.8167 2.10825 18.7412C1.97837 18.6658 1.87059 18.5575 1.79572 18.4273C1.72085 18.2971 1.68151 18.1495 1.68164 17.9993C1.68177 17.8491 1.72138 17.7016 1.79648 17.5715C2.50362 16.3501 3.30719 14.1215 3.30719 10.2858V9.42864Z",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57153 18.8572V19.7143C7.57153 20.6236 7.93276 21.4957 8.57574 22.1387C9.21872 22.7817 10.0908 23.1429 11.0001 23.1429C11.9094 23.1429 12.7815 22.7817 13.4245 22.1387C14.0675 21.4957 14.4287 20.6236 14.4287 19.7143V18.8572",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.d76822c7580daa74ddb18ba65a813ed9.svg";
export { ForwardRef as ReactComponent };